import { render, staticRenderFns } from "./ShipmentsView.vue?vue&type=template&id=208feb54"
import script from "./ShipmentsView.vue?vue&type=script&lang=js"
export * from "./ShipmentsView.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsView.vue?vue&type=style&index=0&id=208feb54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports